import {
  DiscoveryAssistantMode,
  DiscoveryUserMode,
  type DiscoveryMessage,
  type UserPromptMessage,
} from '@/entities/discovery';
import { AssistantMessageSearch } from './assistant-message.search';
import { AssistantMessageSuggestion } from './assistant-message.suggestion';
import { AssistantMessageAnswer } from './assistant-message.answer';
import { AssistantMessageKeywordSelection } from './assistant-message.keyword-selection';
import { AssistantMessageFailure } from './assistant-message.failure';
import { UserMessagePosts } from './user-message.posts';
import { UserMessagePrompt } from './user-message.prompt';
import { AssistantMessageLoading } from './assistant-message.loading';

export const DiscoveryMessageMap = ({
  message,
  nextMessage,
  isCurrent,
}: {
  message: DiscoveryMessage;
  nextMessage?: DiscoveryMessage;
  isCurrent?: boolean;
}) => {
  if (message.role === 'assistant') {
    switch (message.assistant_mode) {
      case DiscoveryAssistantMode.LOADING:
        return <AssistantMessageLoading message={message} />;
      case DiscoveryAssistantMode.SEARCH:
        return <AssistantMessageSearch message={message} isCurrent={isCurrent} />;
      case DiscoveryAssistantMode.SUGGESTION:
        return (
          <AssistantMessageSuggestion
            message={message}
            selected_prompt={getNextUserPromptMessage(nextMessage)?.content.message}
          />
        );
      case DiscoveryAssistantMode.ANSWER:
        return <AssistantMessageAnswer message={message} />;
      case DiscoveryAssistantMode.KEYWORD_SELECTION:
        return <AssistantMessageKeywordSelection message={message} />;
      case DiscoveryAssistantMode.FAILURE:
        return <AssistantMessageFailure message={message} />;
      default:
        throw new Error('Invalid assistant mode');
    }
  }
  if (message.role === 'user') {
    switch (message.user_mode) {
      case DiscoveryUserMode.POSTS:
        return <UserMessagePosts message={message} />;
      case DiscoveryUserMode.PROMPT:
        return <UserMessagePrompt message={message} />;
      default:
        throw new Error('Invalid user mode');
    }
  }
  throw new Error('Invalid message role');
};

function getNextUserPromptMessage(message?: DiscoveryMessage): UserPromptMessage | undefined {
  if (message?.role !== 'user' || message.user_mode !== DiscoveryUserMode.PROMPT) {
    return undefined;
  }

  return message;
}
